const meetingEndingEvent = 'meeting:meeting-ending';
const meetingEndedEvent = 'meeting:meeting-ended';
const meetingLeftEvent = 'meeting:meeting-left';

firebird.factory('uniteNotificationService', [
    '$window',
    '$location',
    'helperService',
    function ($window, $location, helperService) {
        const meetingId = helperService.getMeetingIdentifier($location.absUrl());

        var service = {
            sendMeetingEndingEvent: sendMeetingEndingEvent,
            sendMeetingEndedEvent: sendMeetingEndedEvent,
            sendMeetingLeftEvent: sendMeetingLeftEvent
        };

        return service;

        function sendMeetingEndingEvent() {
            sendMeetingEvent(meetingEndingEvent);
        }

        function sendMeetingEndedEvent() {
            sendMeetingEvent(meetingEndedEvent);
        }

        function sendMeetingLeftEvent() {
            sendMeetingEvent(meetingLeftEvent);
        }

        function sendMeetingEvent(eventName) {
            if (canSendEvent()) {
                $window.opener.postMessage({ type: eventName, payload: meetingId }, '*');
            }
        }

        function canSendEvent() {
            return helperService.isUniteWeb();
        }
    }
]);
